<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelSignature()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="reviewDocument()">
                <ion-icon slot="icon-only" name="document"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>
            Signature For : {{document.documentNumber}} - {{document.customer.cod}}
            - {{document.customer.name}}
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content padding forceOverscroll="false">

    <!-- need to sysconfig hiding questions on countersigning application -->

    <ion-grid>
        <ion-row>
            <ion-col size="8">
                <ion-item lines="none">
                    <ion-label>Contact:</ion-label>
                    <ion-select [(ngModel)]="selectedContact" interface="popover"
                                [compareWith]="contactCompare">
                        <ion-select-option *ngFor="let contact of contactsForCustomer"
                                           [value]="contact">{{contact.name}}</ion-select-option>
                    </ion-select>
                </ion-item>
            </ion-col>
            <ion-col size="4">
                <ion-button (click)="addContact()" color="light">
                    <ion-icon slot="icon-only" name="add"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>


    <canvas class="signature-pad-canvas" [hidden]="!screenLoaded" #imageCanvas width="900" height="400"></canvas>
<!--    <canvas #imageCanvas [hidden]="!screenLoaded" (touchstart)="startDrawing($event)" (touchmove)="moved($event)"-->
<!--            style='border: 1px solid black;'></canvas>-->
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button (click)="saveDocument()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-fab vertical="bottom" horizontal="start">
        <ion-fab-button (click)="clearCanvas()" color="danger">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
